import { Component, DestroyRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { API, DeviceFullDTO, PlayerCullDTO } from 'src/app/services/api/api';
import { ErrorService } from 'src/app/services/error.service';
import { UtilService } from 'src/app/services/util.service';
import { PermissionService } from '../../../../services/permission.service';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { getItemId } from '../../../../services/global/global-methods';

@Component({
  selector: 'sb-page-device-details-overview',
  templateUrl: './device-details-overview.component.html',
  styleUrls: ['./device-details-overview.component.scss'],
  standalone: false,
})
export class DeviceDetailsOverviewComponent implements OnInit {
  protected readonly getItemId = getItemId;
  deviceId: number;
  device: DeviceFullDTO;

  cullsLoading: boolean;
  loading: boolean;

  culls: PlayerCullDTO[];
  notes: string;

  constructor(
    private readonly api: API,
    private readonly activatedRoute: ActivatedRoute,
    public readonly util: UtilService,
    public readonly errorHandler: ErrorService,
    public readonly permissionService: PermissionService,
    private readonly destroyRef: DestroyRef
  ) {
    this.deviceId = undefined;
    this.device = undefined;
    this.cullsLoading = true;
    this.loading = true;
    this.culls = null;
  }

  ngOnInit() {
    this.activatedRoute.parent.params.subscribe(params => {
      this.deviceId = +params.deviceID;
      this.refresh();
    });
  }

  refresh() {
    this.loading = true;
    this.api
      .ss_nm_Device_retrieveFullById(this.deviceId)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (e: DeviceFullDTO) => {
          this.device = e;
          this.notes = this.device.notes;
          this.cullsLoading = true;
          this.api
            .ss_nm_Device_retrieveFittingCulls(this.deviceId)
            .pipe(
              takeUntilDestroyed(this.destroyRef),
              take(1),
              finalize(() => {
                this.cullsLoading = false;
              })
            )
            .subscribe({
              next: (culls: PlayerCullDTO[]) => {
                this.culls = culls;
              },
              error: error => {
                this.errorHandler.errorHandler(error);
              },
            });
        },
        error: error => {
          if (!error.status || !(+error.status === 403 || +error.status === 404)) {
            this.errorHandler.errorHandler(error);
          }
        },
      });
  }

  saveNotes() {
    if (this.permissionService.hasPermission(this.permissionService.Permission.device_properties_edit)) {
      this.device.notes = this.notes;
      this.api
        .ss_nm_Device_editDevice(this.device)
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe({
          next: (dev: DeviceFullDTO) => {
            this.device = dev;
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    }
  }
}
